import React from 'react';
import { Bookmark } from 'lucide-react';
import { useMenuFavoritesStore } from '../store/menuFavoritesStore';

type Props = {
  itemId: string;
  className?: string;
  size?: number;
  /** Цвет активной закладки */
  activeColor?: string;
  /** Цвет неактивной */
  inactiveColor?: string;
};

export function MenuFavoriteButton({
  itemId,
  className = '',
  size = 15,
  activeColor = '#fff',
  inactiveColor = 'rgba(255,255,255,0.35)',
}: Props) {
  const active = useMenuFavoritesStore((s) => s.ids.includes(itemId));
  const toggleFavorite = useMenuFavoritesStore((s) => s.toggleFavorite);

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        toggleFavorite(itemId);
      }}
      className={`shrink-0 inline-flex items-center justify-center active:scale-90 transition-transform p-1 -m-1 ${className}`}
      aria-label={active ? 'Убрать из избранного' : 'В избранное'}
      aria-pressed={active}
      title={active ? 'Убрать из избранного' : 'В избранное'}
    >
      <Bookmark
        size={size}
        fill={active ? activeColor : 'none'}
        strokeWidth={1.75}
        style={{ color: active ? activeColor : inactiveColor }}
      />
    </button>
  );
}
